export default "/images/f8c2e45e72da8018549dcbcab8e0722f.png";